<div class="card">
    <div class="card-header">
        <h2 class="h2">Solicitudes de Depósitos</h2>
    </div>
	<div class="card-body">
        <div class="row mb-3">
            <div class="col-12 col-sm-6">
                <div class="row">
                    <div class="col form-group">
							<label for="startDate" class="form-label">Fecha Inicio <span class="required">*</span></label>
							<input type="date" name="startDate" id="startDate" (change)="getDepositRequests()"
								[(ngModel)]="startDate" class="form-control">
						</div>
                </div>
                <div class="row">
                    <div class="table-responsive" style="max-height: 400px;">
                        <table class="table" style="margin-bottom: 0; margin-top: 10px;">
                            <thead>
                                <tr class="tr-middle">
                                    <th class="ta">
                                        Bodega/Camión
                                    </th>
                                    <th class="limit-td">
                                        FACT
                                    </th>
                                    <th class="ta">
                                        CF
                                    </th>
                                    <th class="ta">
                                        Auxiliar
                                    </th>
                                    <th class="ta">
                                        Cooperativa
                                    </th>
                                    <th class="ta">
                                        EFECTIVO
                                    </th>
                                    <th class="ta">
                                        Fecha
                                    </th>
                                    <th class="ta">Estado</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="tr-middle cursor-pointer" *ngFor="let item of depositRequest" (click)="setResponseSelected(item)"
                                    [class.tr-active]="requestSelected!=null && requestSelected.id == item.id" class="hover:bg-gray-100 px-2">
                                    <td class="col cursor-pointer" [class.bg-blue-50]="requestSelected!=null && requestSelected.id == item.id" [class.font-bold]="requestSelected!=null && requestSelected.id == item.id">{{warehousesName[item.warehouseAdmin]}}</td>
                                    <td class="col cursor-pointer" [class.bg-blue-50]="requestSelected!=null && requestSelected.id == item.id" [class.font-bold]="requestSelected!=null && requestSelected.id == item.id">{{item.invoiceAmount | currency:'Q':'symbol':'1.2-2'}}</td>
                                    <td class="col cursor-pointer" [class.bg-blue-50]="requestSelected!=null && requestSelected.id == item.id" [class.font-bold]="requestSelected!=null && requestSelected.id == item.id">{{item.cfAmount | currency:'Q':'symbol':'1.2-2'}}</td>
                                    <td class="col cursor-pointer" [class.bg-blue-50]="requestSelected!=null && requestSelected.id == item.id" [class.font-bold]="requestSelected!=null && requestSelected.id == item.id">{{item.auxiliarAmount | currency:'Q':'symbol':'1.2-2'}}</td>
                                    <td class="col cursor-pointer" [class.bg-blue-50]="requestSelected!=null && requestSelected.id == item.id" [class.font-bold]="requestSelected!=null && requestSelected.id == item.id">{{item.cooperativeAmount | currency:'Q':'symbol':'1.2-2'}}</td>
                                    <td class="col cursor-pointer" [class.bg-blue-50]="requestSelected!=null && requestSelected.id == item.id" [class.font-bold]="requestSelected!=null && requestSelected.id == item.id">{{item.adminAmount | currency:'Q':'symbol':'1.2-2'}}</td>
                                    <td class="col cursor-pointer" [class.bg-blue-50]="requestSelected!=null && requestSelected.id == item.id" [class.font-bold]="requestSelected!=null && requestSelected.id == item.id">{{item.createdAt | date:'dd/MM/yyyy HH:mm:ss'}}</td>
                                    <td class="col cursor-pointer" [class.bg-blue-50]="requestSelected!=null && requestSelected.id == item.id" [class.font-bold]="requestSelected!=null && requestSelected.id == item.id">
                                        <span class="badge bg-danger" *ngIf="item.invoiceBankAccountId==null && item.cfBankAccountId==null">Sin Asignar</span>
                                        <span class="badge bg-warning" *ngIf="(item.invoiceBankAccountId==null && item.cfBankAccountId!=null) || (item.invoiceBankAccountId!=null && item.cfBankAccountId==null)">Incompleto</span>
                                        <span class="badge bg-success" *ngIf="item.invoiceBankAccountId!=null && item.cfBankAccountId!=null">Asignado</span>
                                    </td>
                                </tr>

                                <tr class="tr-middle" *ngIf="loadingData">
                                    <td colspan="5">
                                        <app-loading-animation [height]="'5rem'"></app-loading-animation>
                                        <p class="display-5">Cargando</p>
                                    </td>
                                </tr>

                                <tr class="tr-middle" *ngIf="!loadingData && depositRequest.length == 0">
                                    <td colspan="5">
                                        <span class="display-5 text-center">
                                            <div class="empty-icon-container">
                                                <!-- <div class="empty-icon-animation">
                                                    <i class="fa-solid fa-exclamation"></i>
                                                </div> -->
                                                <i class="fa fa-database"></i>
                                            </div>
                                            No se cuenta con Solicitudes de Depósito
                                        </span>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="col-12 col-sm-6">
                <div class="row mb-3 mt-5" *ngIf="requestSelected!=null">
                    <div class="col-6 form-group mb-3">
                        <label for="bank" class="form-label">Banco para FACT</label>
                        <select name="bank" [disabled]="banksFact==null || banksFact.length == 0" [(ngModel)]="accountSelectedFACT" [disabled]="loadingBankFact"
                            id="bank" class="form-select">
                            <ng-container *ngIf="banksFact==null || banksFact.length == 0">
                                <option value="undefined">No tiene cuentas</option>
                            </ng-container>
                            <ng-container *ngIf="banksFact && banksFact.length > 0">
                                <option value="undefined">Selecciona una cuenta</option>
                            </ng-container>
                            <option *ngFor="let bank of banksFact" value="{{bank.id}}">{{bank.accountNumber}} - {{bank.alias}}
                            </option>
                        </select>
                    </div>
                    <div class="col-6 form-group mb-3">
                        <label for="bank" class="form-label">Banco para CF</label>
                        <select name="bank" [disabled]="banksCF==null || banksCF.length == 0" [(ngModel)]="accountSelectedCF" [disabled]="loadingBankCF"
                            id="bank" class="form-select">
                            <ng-container *ngIf="banksCF==null || banksCF.length == 0">
                                <option value="undefined">No tiene cuentas</option>
                            </ng-container>
                            <ng-container *ngIf="banksCF && banksCF.length > 0">
                                <option value="undefined">Selecciona una cuenta</option>
                            </ng-container>
                            <option *ngFor="let bank of banksCF" value="{{bank.id}}">{{bank.accountNumber}} - {{bank.alias}}
                            </option>
                        </select>
                    </div>
                    <div
                        class="col-6 form-group mb-3"
                        *ngIf="requiresAuxiliar()">

                        <label
                            for="bankAuxiliar"
                            class="form-label">
                            Banco para Auxiliar
                        </label>

                        <select
                            name="bankAuxiliar"
                            id="bankAuxiliar"
                            class="form-select"
                            [(ngModel)]="accountSelectedAuxiliar"
                            [disabled]="
                            loadingBankAuxiliar ||
                            banksAuxiliar == null ||
                            banksAuxiliar.length == 0
                            ">

                            <ng-container
                            *ngIf="
                                banksAuxiliar == null ||
                                banksAuxiliar.length == 0
                            ">
                            <option value="undefined">
                                No tiene cuentas
                            </option>
                            </ng-container>

                            <ng-container
                            *ngIf="
                                banksAuxiliar &&
                                banksAuxiliar.length > 0
                            ">
                            <option value="undefined">
                                Selecciona una cuenta
                            </option>
                            </ng-container>

                            <option
                            *ngFor="let bank of banksAuxiliar"
                            [value]="bank.id">

                            {{bank.accountNumber}} - {{bank.alias}}

                            </option>

                        </select>

                        </div>
                    <div class="col-6 form-group mb-3" *ngIf="requestSelected?.cooperativeBankAccountId != null">
                        <label for="bankCooperative" class="form-label">Banco para Cooperativa</label>
                        <select
                            name="bankCooperative"
                            id="bankCooperative"
                            class="form-select"
                            [(ngModel)]="accountSelectedCooperative"
                            [disabled]="loadingBankCooperative || banksCooperative == null || banksCooperative.length == 0">
                            
                            <ng-container *ngIf="banksCooperative == null || banksCooperative.length == 0">
                                <option value="undefined">No tiene cuentas</option>
                            </ng-container>

                            <ng-container *ngIf="banksCooperative && banksCooperative.length > 0">
                                <option value="undefined">Selecciona una cuenta</option>
                            </ng-container>

                            <option *ngFor="let bank of banksCooperative" [value]="bank.id">
                                {{bank.accountNumber}} - {{bank.alias}}
                            </option>
                        </select>
                    </div>
                    <div class="col-12 mb-3 d-flex flex-row justify-content-end">
                        <button class="btn btn-success" (click)="sendResponse()"
                            [disabled]="loading 
                                || accountSelectedCF == null 
                                || accountSelectedFACT == null 
                                || requestSelected == null
                                || (requestSelected?.cooperativeBankAccountId != null && accountSelectedCooperative == null)
                                || (requiresAuxiliar() && accountSelectedAuxiliar == null)">
                            <ng-container *ngIf="!loading">
                                <i class="fa fa-floppy-disk"></i>
                            </ng-container>
                            <ng-container *ngIf="loading">
                                <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                                <span role="status"></span>
                            </ng-container> Responder Depósito
                        </button>
                    </div>
                </div>
            </div>
        </div>

	</div>

</div>